import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-copied-promocode-tooltip',
  imports: [],
  templateUrl: './copied-promocode-tooltip.component.html',
  styleUrl: './copied-promocode-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopiedPromocodeTooltipComponent {}
